import { FunctionComponent, useEffect, useState } from 'react'
import styles from './settings.module.scss'
import ExportSettings from './export/exportSettings'
import BlackListSettings from './blacklist/blacklist'
import AccountSettings from './account/account'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Api, ArrowBack, CalendarMonth } from '@mui/icons-material'
import CronSettings from './cron/cron'
import ApiClientList from '@/container/settings/apiClient/apiClientList.tsx'

const Settings: FunctionComponent = () => {
    const { t } = useTranslation()

    const [showCron, setShowCron] = useState<boolean>(false)
    const [showAPI, setShowAPI] = useState<boolean>(false)

    useEffect(() => {
        const searchParams: string = window.location.hash.substring(1)
        if (searchParams === 'apiClient') setShowAPI(true)
    }, [window.location])

    return (
        <>
            {showCron ? (
                <>
                    <div className={styles.Container}>
                        <CronSettings />
                    </div>
                    <div className={styles.Container}>
                        <div className={styles.ShowCronPlacement}>
                            <ButtonTextIcon
                                type={'custom'}
                                customIcon={<ArrowBack />}
                                customText={t('backToParameters')}
                                onClick={() => setShowCron(false)}
                                className={styles.Button}
                            />
                        </div>
                    </div>
                </>
            ) : showAPI ? (
                <div className={styles.Container}>
                    <ApiClientList backToParameters={() => setShowAPI(false)} />
                </div>
            ) : (
                <>
                    <div className={styles.Container}>
                        <ExportSettings />
                    </div>
                    <div className={styles.Container}>
                        <AccountSettings />
                    </div>
                    <div className={styles.Container}>
                        <BlackListSettings />
                    </div>
                    <div className={styles.Container}>
                        <div className={styles.ButtonContainer}>
                            <ButtonTextIcon
                                type={'custom'}
                                customIcon={<Api />}
                                customText={t('showExternalApiClient')}
                                onClick={() => setShowAPI(true)}
                                className={styles.Button}
                            />
                            <ButtonTextIcon
                                type={'custom'}
                                customIcon={<CalendarMonth />}
                                customText={t('showCron')}
                                onClick={() => setShowCron(true)}
                                className={styles.Button}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default Settings
